'use strict';

module.exports = require('./dom-scroll-into-view');


//////////////////
// WEBPACK FOOTER
// ./~/dom-scroll-into-view/lib/index.js
// module id = 68
// module chunks = 0 1 2 3